
const GetRankClass = function (num) {
    if (!num) {
        return { unknown: true, title: "" }
    }

    let percentile = parseInt(num);

    if (percentile <= 5) {
        return { excellent: true, title: "ดีที่สุด" };
    } else if (percentile <= 25) {
        return { great: true, title: "ดีมาก" };
    } else if (percentile <= 50) {
        return { good: true, title: "ดี" };
    }

    return { medium: true, title: "ปานกลาง" };

}

export {
    GetRankClass,
}
